<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">云管网管理</div>
    </div>
    <div class="page-body">
      <!--
      <el-form class="ezz-list-search" size="mini" :inline="true">
        <el-form-item label="站点名称">
          <el-input size="mini" placeholder="站点名称" v-model="query.raw_admin_code" style="width: 130px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="注册日期">
          <el-date-picker type="daterange" size="mini" v-model="dateRange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 240px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="success" plain icon="el-icon-search" @click="handlerSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      -->
      <el-button v-if="!lastSlider.editstatus" size="mini" type="primary" icon="el-icon-plus" style="margin-bottom:10px" @click="handlerAddSlider">添加图片</el-button>
      <el-table :data="dataList" size="mini" border header-row-class-name="datalist-header" style="width: 100%" @row-click="rowClick">
        <el-table-column prop="sort" label="排序" align="center" width="60">
          <template v-slot:default="scope">
            <el-input v-if="scope.row.editstatus" v-model="scope.row.sort"></el-input>
            <span v-else>{{scope.row.sort}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="唯一标识 id" align="center">
        </el-table-column>
        <el-table-column prop="img_url" label="图片" align="center">
          <!-- 图片的显示 -->
          <template slot-scope="scope">
            <el-upload v-if="scope.row.editstatus" :before-upload="beforeAvatarUpload" :file-list="fileList" :action="apis.uploadImg" :limit="1" :on-success="handleAvatarSuccess" list-type="picture">
              <el-button size="small" type="primary">点击上传图片</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
            <img v-if="scope.row.img_url!==''" :src="web_Url + scope.row.img_url" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="contactor" label="图片说明" align="center">
          <template v-slot:default="scope">
            <el-input v-if="scope.row.editstatus" v-model="scope.row.remark"></el-input>
            <span v-else>{{scope.row.remark}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template v-slot:default="scope">
            <template v-if="scope.row.id === '系统自动生成'">
              <el-button type="success" size="mini" icon="el-icon-finished" circle @click="save(scope.row)"></el-button>
              <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="handlerDel(scope.row, scope.$index)"></el-button>
            </template>
            <template v-if="scope.row.id !== '系统自动生成'">
              <el-button :type="scope.row.editstatus?'success':'warning'" size="mini" :icon="scope.row.editstatus?'el-icon-finished':'el-icon-edit'" circle @click="scope.row.editstatus?save(scope.row):isEditedable(scope.row)"></el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handlerDel(scope.row, scope.$index)"></el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px;" @size-change="handlerSizeChange" @current-change="handlerCurrentChange" :current-page="query.pn" :page-sizes="[15, 30, 50, 100]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountList',
  data: () => {
    return {
      operate_id: JSON.parse(sessionStorage.getItem('user')).id,
      web_Url: window.g.baseUrl,
      apis: {
        GetList: window.g.baseUrl + 'plugin/user/website/Slider/GetList',
        uploadImg: window.g.baseUrl + 'plugin/user/website/Slider/UploadImage',
        save: window.g.baseUrl + 'plugin/user/website/Slider/Save'
      },
      query: {
        site_name: '',
        startDate: '',
        endDate: '',
        pageSize: 15,
        pn: 1
      },
      emptySlider: {
        id: '0',
        img_url: '',
        remark: '',
        sort: '0',
        create_time: '',
        update_time: '',
        delete_time: '',
        creater_id: '0',
        updater_id: '0',
        deleter_id: '0'
      },
      fileList: [],
      currentRow: {},
      dataList: [],
      companyList: [],
      lastSlider: { editstatus: false },

      // 日期范围
      dateRange: [],
      dataList: [],
      pageCount: 0,
      totalCount: 0
    }
  },
  mounted: function () {
     this.loadData()
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === ('image/jpeg' || file.type === 'image/png')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    rowClick: function (row) {
      this.currentRow = row
      console.log(row.logo)
    },
    handleAvatarSuccess(res, file, fileList) {
      const _this = this
      _this.currentRow.img_url = res.url
    },

    GetNowDateTime: function () {
      var data = new Date()
      var month = data.getMonth() < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
      var date = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()
      var hour = data.getHours < 10 ? '0' + data.getHours() : data.getHours()
      var minute = data.getMinutes < 10 ? '0' + data.getMinutes : data.getMinutes()
      var second = data.getSeconds < 10 ? '0' + data.getSeconds : data.getSeconds()
      var value = data.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
      return value
    },
    save: function (model) {
      this.currentRow = model
      if (model.id === '系统自动生成') {
        model.creater_id = this.operate_id
        model.create_time = this.GetNowDateTime()
        this.handlerSave(model)
      } else {
        model.update_id = this.operate_id
        model.updater_time = this.GetNowDateTime()
        this.handlerSave(model)
      }
    },

    delete: function (model) {
      model.deleter_id = this.operate_id
      model.delete_time = this.GetNowDateTime()
      this.handlerSave(model)
    },

    isEditedable: function (row) {
      this.$set(row, 'editstatus', true)
    },

    // 保存
    handlerSave: function (model) {
      const _this = this
      if (_this.validationHandler(model)) {
        _this.post(_this.apis.save, model, function (res) {
          const _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '操作成功',
              type: 'success'
            })
            _this.loadData()
            _this.lastSlider.editstatus = false
          } else {
            _this.$message.error(_json.msg)
          }
        })
      }
    },
    handlerDel: function (_row, _index) {
      const _this = this
      _this
        .$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          if (_row.id === '系统自动生成') {
            _this.$delete(_this.dataList, _index)
            _this.lastSlider.editstatus = false
          } else _this.delete(_row)
        })
    },


    handlerAddSlider: function () {
      const sonSlider = JSON.parse(JSON.stringify(this.emptySlider))
      sonSlider.editstatus = true
      sonSlider.id = '系统自动生成'
      sonSlider.create_time = '系统自动生成'
      this.dataList.push(sonSlider)
      this.lastSlider = sonSlider
    },

    // 表单验证
    validationHandler: function (model) {
      const _this = this
      if (_this.$fun.trimAll(model.img_url) === '') {
        _this.$message({
          message: '图片不能为空',
          type: 'warning'
        })
        return false
      }
      return true
    },
    loadData: function () {
      const _this = this
      _this.post(_this.apis.GetList, _this.query, function (res) {
        const _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.$router.replace({
            path: '/'
          })
        } else {
          _this.dataList = _json.dataList
          _this.totalCount = _json.totalCount
          _this.query.pn = _json.pn
        }
      })
    },
    handlerSearch: function () {
      this.loadData()
    },
    handlerSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    handlerCurrentChange: function (pageIndex) {
      this.query.pn = pageIndex
      this.loadData()
    }
  }
}
</script>